import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

import './index.css';
import '~/icons/fs-icons.css';
//import registerServiceWorker from './registerServiceWorker';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Removed this call to opt-out of caching
// registerServiceWorker();
